/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { IEventDescriptionData } from './event-description.data';
import { IEventDescriptionProps } from './event-description.props.autogenerated';

/**
 *
 * EventDescription component
 * @extends {React.PureComponent<IEventDescriptionProps<IEventDescriptionData>>}
 */
class EventDescription extends React.PureComponent<IEventDescriptionProps<IEventDescriptionData>> {
    public render(): JSX.Element | null {
        const { eventDescription } = this.props.data;
        if (eventDescription.result && (eventDescription.result.intro || eventDescription.result.body)) {
            return (
                <div className='product-attribute'>
                    <div className='product-attribute-nv product-attribute-event-description'>
                        {eventDescription.result.intro && this._renderEventDescription(eventDescription.result.intro, 'intro')}
                        {eventDescription.result.body && this._renderEventDescription(eventDescription.result.body, 'body')}
                    </div>
                </div>
            );
        }
        return null;
    }

    private _renderEventDescription(eventDescription: string, className: string): JSX.Element {
        return (
            <RichTextComponent
                className={`product-attribute-nv-value product-attribute-event-description-${className}`}
                text={eventDescription}
            />
        );
    }
}

export default EventDescription;
